module.exports = {
	"projects": [
		{
			"className": "SociallyFox",
			"description": "Soyez influent et populaire.",
			"clientDescription": "Plus de 20 astuces pour vous aidez à être socialement bon dans votre vie quotidienne",
			"slug": "sociallyfox",
			"title": "Socially Fox",
			"appleUrl": "https://itunes.apple.com/WebObjects/MZStore.woa/wa/viewSoftware?id=1207978654&mt=8",
			"googleUrl": "https://play.google.com/store/apps/details?id=com.sociallyfox"
		},
		{
			"className": "SwiPolitique",
			"description": "Triez les candidats à la Présidentielle.",
			"clientDescription": "N'hésitez plus pour les présidentielles 2017",
			"slug": "swipolitique",
			"title": "Swip Politique",
			"appleUrl": "https://itunes.apple.com/us/app/swipolitique/id1211013703?mt=8",
			"googleUrl": "https://play.google.com/store/apps/details?id=com.swipolitique"
		},
		{
			"className": "Incruizer",
			"description": "Un réseau social basé sur la géolocalisation.",
			"clientDescription": "Partager ce que vous voyez pour le monde entier.",
			"slug": "incruizer",
			"title": "Incruizer",
			"appleUrl": "https://itunes.apple.com/fr/app/caoua/id1234612758?mt=8",
			"googleUrl": "https://play.google.com/store/apps/details?id=com.caoua"
		},
		{
			"className": "Animalz",
			"description": "Passez la meilleur soirée de votre vie.",
			"clientDescription": "Ne ratez plus vos artistes préférés avec vos amis !",
			"slug": "animalz",
			"title": "Animalz",
			"appleUrl": "https://itunes.apple.com/us/app/animalz/id1370171306?l=fr&ls=1&mt=8",
			"googleUrl": "https://play.google.com/store/apps/details?id=com.animalz"
		},
		{
			"className": "Caoua",
			"description": "Savourez votre café en bonne compagnie (version bêta).",
			"clientDescription": "Localisez les meilleurs cafées prêt de chez vous.",
			"slug": "caoua",
			"title": "Caoua",
			"appleUrl": "https://itunes.apple.com/fr/app/caoua/id1234612758?mt=8",
			"googleUrl": "https://play.google.com/store/apps/details?id=com.caoua"
		},
		{
			"className": "LeBonChoix",
			"description": "Soyez sûr(e) de vos choix.",
			"clientDescription": "La vie est un ensemble de choix.",
			"slug": "lebonchoix",
			"title": "LeBonChoix",
			"appleUrl": "https://itunes.apple.com/fr/app/lebonchoix/id1237902665?mt=8",
			"googleUrl": "https://play.google.com/store/apps/details?id=com.lebonchoix"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ../data/projects.json
// module id = 467
// module chunks = 0